import * as React from "react";
import type { SVGProps } from "react";
const SvgCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <rect
      width={11.671}
      height={11.671}
      x={5.832}
      y={5.832}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      rx={1.667}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M5.831 14.17H4.164c-.92 0-1.667-.747-1.667-1.668V4.165c0-.92.746-1.667 1.667-1.667H12.5c.92 0 1.667.747 1.667 1.667v1.668"
    />
  </svg>
);
export default SvgCopy;
